module.exports = __webpack_public_path__ + "fonts/roboto-v27-latin-ext_latin-700.96fb238.ttf";